/**
 * Earned Wage Access — employee self-service API (P07).
 */
import apiClient from '@/api/client';

export interface EwaEligible {
  basic_salary: string;
  earned_to_date: string;
  max_draw_pct: string;
  eligible: string;
  already_drawn: string;
  available_to_draw: string;
  period_year: number;
  period_month: number;
}

export interface EwaDraw {
  id: string;
  draw_amount: string;
  status: string;
  period_year: number;
  period_month: number;
  created_at: string | null;
  approved_at: string | null;
}

export const ewaApi = {
  eligible: () => apiClient.get<EwaEligible>('/hr/ewa/eligible').then((r) => r.data),
  myDraws: () => apiClient.get<EwaDraw[]>('/hr/ewa/my-draws').then((r) => r.data),
  requestDraw: (amount: number) =>
    apiClient
      .post<{ id: string; status: string; draw_amount: string }>('/hr/ewa/draw-request', { amount })
      .then((r) => r.data),
};
